import React, {Component} from 'react';
import {Button, Modal, Form, Table, Checkbox} from 'semantic-ui-react';

import ClientData from "../../data/ClientData";
import connect from "react-redux/es/connect/connect";
import {showFindClientModal} from "../../actions/FindClientAction";
import localDB from "../../data/localDB";
import {showToast} from "../../actions/ToastAction";
import {selectClient} from "../../actions/ClientSelectActions";
import {clientDialog} from "../../actions/ClientDialogAction";
import LoadingRow from "../extras/LoadingRow";

class FindClient extends Component {

    constructor(props) {
        super(props);

        this.state = {
            client: {
                full_name: '',
                identification: '',
                phone: '',
                email: '',
                address: '',
                id: null
            },
            clients:[],
            clients_old:[],
            client_select: null,
            btn_get_client: false,
            search: '',
            loading: true
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleCheckboxChange = this.handleCheckboxChange.bind(this);
        this.getClient = this.getClient.bind(this);
        this.handleSelectClient = this.handleSelectClient.bind(this);
        this.newClient = this.newClient.bind(this);
    }

    async componentWillReceiveProps(nextProps){
        if(nextProps.find_client){
            await this.loadData();
            this.setState({loading:false});
        }
        if(nextProps.select_client && nextProps.select_client.hasOwnProperty('id')){
            let select_client = Object.assign(nextProps.select_client,{});
            let state_clients = Object.assign(this.state.clients,{});
            let clients = state_clients.map(client => {
                client = select_client.id === client.id ? select_client:client;
                return client
            });
            this.setState({clients, clients_old:clients});
        }
    }

    async componentWillMount(){
        await this.loadData();
    }

    async loadData() {
        let clients = await localDB.getDB('clients');
        this.setState({clients, clients_old: clients});
    };

    handleClose = () => {
        this.props.showFindClientModal({open:false})
    };

    handleChange = (search) => {
        let clients = this.state.clients_old.filter(client => {
            if(client !== undefined){
                return client.full_name.toLowerCase().includes(search.toLowerCase()) || client.identification.toLowerCase().includes(search.toLowerCase()) || client.phone.toLowerCase().includes(search.toLowerCase())
            }
        });
        this.setState({clients, search});
    };

    handleCheckboxChange = (e, { value }) => {
        this.setState({ client_select:value })
    };

    handleSelectClient = () => {
        let client = this.state.clients[this.state.client_select];
        if(client){
            this.props.selectClient(client);
            this.props.showFindClientModal({open:false});
        }else{
            this.props.showToast({message: 'Por favor seleccione un cliente!', type: 'error'})
        }
    };

    getClient(client) {
        this.setState({btn_get_client:true});
        ClientData.get(client.id, (client)=>{
            this.setState({btn_get_client:false});
            this.props.clientDialog({open:true, client});
        });
    };

    newClient() {
        this.props.clientDialog({
            open:true,
            client:{
                id:null,
                full_name: this.state.search
            }
        });
    };

    render() {
        return (
            <div>
                <Modal size='small' dimmer='inverted' open={this.props.find_client.open} onClose={this.handleClose}>
                    <Modal.Header>Cliente</Modal.Header>
                    <Modal.Content image scrolling>
                        <Modal.Description>
                            <Form onSubmit={this.handleSubmit}>
                                <Form.Input icon='user' placeholder='Buscar cliente...' onChange={e => this.handleChange(e.target.value)}/>
                            </Form>
                            <Table celled compact definition>
                                <Table.Header fullWidth>
                                    <Table.Row>
                                        <Table.HeaderCell>Seleccionar</Table.HeaderCell>
                                        <Table.HeaderCell>Cliente</Table.HeaderCell>
                                        <Table.HeaderCell>Identificación</Table.HeaderCell>
                                        <Table.HeaderCell>Teléfono</Table.HeaderCell>
                                        <Table.HeaderCell>Acciones</Table.HeaderCell>
                                    </Table.Row>
                                </Table.Header>
                                <Table.Body>
                                    {!this.state.loading ? this.state.clients.length > 0 ? this.state.clients.slice(0,5).map(function (client, index) {
                                        return (
                                            <Table.Row key={client.id}>
                                                <Table.Cell collapsing>
                                                    <Checkbox
                                                        toggle
                                                        name='cbx_client'
                                                        value={index}
                                                        checked={this.state.client_select === index}
                                                        onChange={this.handleCheckboxChange}
                                                    />
                                                </Table.Cell>
                                                <Table.Cell>{client.full_name}</Table.Cell>
                                                <Table.Cell>{client.identification ? client.identification:'-'}</Table.Cell>
                                                <Table.Cell>{client.phone ? client.phone:'-'}</Table.Cell>
                                                <Table.Cell>
                                                    <Button
                                                        size='small'
                                                        content='Editar'
                                                        icon='pencil'
                                                        labelPosition='left'
                                                        onClick={()=>this.getClient(client)}
                                                    />
                                                </Table.Cell>
                                            </Table.Row>
                                        )
                                    }, this) :<Table.Row>
                                        <Table.Cell colSpan={5}>
                                            <Button primary icon='user'
                                                    labelPosition='left'
                                                    fluid
                                                    onClick={this.newClient}
                                                    content='Cliente No Encontrado, ¿Agregar Cliente?'/>
                                        </Table.Cell>
                                    </Table.Row>:<LoadingRow colSpan={3}/>}
                                </Table.Body>
                            </Table>
                        </Modal.Description>
                    </Modal.Content>
                    <Modal.Actions>
                        <Button icon='x' labelPosition='left' onClick={this.handleClose} content="Cancelar"/>
                        <Button primary icon='user'
                                labelPosition='left'
                                onClick={this.handleSelectClient}
                                content='Seleccionar cliente'/>
                    </Modal.Actions>
                </Modal>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        find_client: state.get('find_client'),
        select_client: state.get('select_client'),
    };
}

function mapDispatchToProps(dispatch) {
    return {
        showFindClientModal(data) {
            dispatch(showFindClientModal(data));
        },
        showToast(data){
            dispatch(showToast(data))
        },
        selectClient(client){
            dispatch(selectClient(client))
        },
        clientDialog(client){
            dispatch(clientDialog(client))
        }
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(FindClient);


// WEBPACK FOOTER //
// ./src/components/contacts/FindClient.js